export const API_TOKEN_ALERT_DISMISS_KEY = 'rs_api_token_alert_dismissed';

export function clearApiTokenDismissSession() {
  try {
    sessionStorage.removeItem(API_TOKEN_ALERT_DISMISS_KEY);
  } catch (_) {
    /* ignore */
  }
}
